module.exports = "/_next/static/images/web3-acceleration-banner-icon-cd161219b23cb66c10252157f4d32bf9.webp";